@if (vendor) {
  <div
    role="img"
    [attr.aria-label]="vendor | cardVendorTitle"
    [title]="vendor | cardVendorTitle"
    class="bb-card-vendor"
    [ngClass]="className"
  ></div>
}
